export const EnglishStr = {
    ContactCentrePhone:'1-866-592-2226'
}